import { API_BASE_URL_CANDIDATES, buildApiUrl } from '../config/api';
import { fetchWithTimeout } from './http';

async function parseResponse(response) {
  const contentType = response.headers.get('content-type') || '';

  if (contentType.includes('application/json')) {
    return response.json();
  }

  return response.text();
}

function buildErrorMessage(status, payload) {
  if (payload && typeof payload === 'object' && typeof payload.message === 'string') {
    return payload.message;
  }

  return `Request failed: ${status}`;
}

export async function submitAppeal(payload) {
  const errors = [];

  for (const baseUrl of API_BASE_URL_CANDIDATES) {
    try {
      const response = await fetchWithTimeout(buildApiUrl('/api/appeals', baseUrl), {
        method: 'POST',
        cache: 'no-store',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const data = await parseResponse(response);

      if (!response.ok) {
        const error = new Error(buildErrorMessage(response.status, data));
        error.status = response.status;
        throw error;
      }

      return data?.item || null;
    } catch (error) {
      if (error?.status) {
        throw error;
      }

      errors.push(error);
    }
  }

  const networkError = new Error("Backend server bilan aloqa yo'q.");
  networkError.cause = errors[errors.length - 1];
  throw networkError;
}
